module.exports = __webpack_public_path__ + "static/media/tour-guide.a25bbf47.png";